var modals = require("../modals");
var utils = require("../shared/utils");
var googleAnalytics = require("./googleAnalytics");

var handlers = {
    communityModal(e) {
        e.preventDefault();
        var url = $(this).attr("href");
        modals.launch(url).then(result => console.log(result));
    },
    teaserLink(e) {
        // if they aren't authenticated
        if (!utils.isAuthenticated()) {
            e.preventDefault();
            var target = encodeURIComponent($(this).attr("href"));
            var modalUrl = _spPageContextInfo.siteAbsoluteUrl + "/pages/loginmodal.aspx"
            var intendedUrl = encodeURIComponent(modalUrl + "?loginSuccess=true");
            var url = `${modalUrl}?IntendedUrl=${intendedUrl}&teaserUrl=${target}`;
            modals.launch(url).then(result => {
                // only redirect if we get a status of 1 from login page
                if (result.status === 1) window.location.href = decodeURIComponent(target);
            })
        };
    },
    loginModalLink(e) {
        e.preventDefault();
        window.top.location.href = e.target.href;
    },
    accordian(e){
        e.preventDefault();
        $(this).closest('div').next('.togglebody,.togglebar-wrapper-body').slideToggle();

        if($(this).children('span').hasClass('halflings-triangle-right')){
            $(this).children('span').removeClass('halflings-triangle-right');    
            $(this).children('span').addClass('halflings-triangle-bottom');
        }else{
            $(this).children('span').removeClass('halflings-triangle-bottom');    
            $(this).children('span').addClass('halflings-triangle-right');
        }

        $(this).toggleClass('active');
    },

    readmore(e){
        $(this).closest('div').next('.togglebody').slideToggle();
        
        if($(this).hasClass('closed')){
            $(this).text('Read Less');
        }else {
            $(this).text('Read More');
        }
        
        $(this).toggleClass('closed');
    },

       
    tgdetails(e){
        $(this).closest('div').next('.togglebody').slideToggle();
        
        if($(this).hasClass('closed')){
            $(this).text('View fewer details -');
        }else {
            $(this).text('View more details +');
        }
        
        $(this).toggleClass('closed');      
    },

    tgschedule(e){
        $(this).closest('div').next('.togglebody').slideToggle();
                
        if($(this).hasClass('closed')){
            $(this).text('Hide schedule -');
        }else {
            $(this).text('Show schedule +');
        }
        
        $(this).toggleClass('closed');   
    },

    tgscpechart(e){
        $(this).closest('div').next('.togglebody').slideToggle();
                
        if($(this).hasClass('closed')){
            $(this).text('Hide full CPE chart -');
        }else {
            $(this).text('Show full CPE chart +');
        }
        
        $(this).toggleClass('closed');   
    }
        


};

exports.bind = function () {
    jQuery("body").on("click", ".NATP-Community-Modal", handlers.communityModal);
    jQuery("body").on("click", ".teaser-link", handlers.teaserLink);
    jQuery("body").on("click", ".togglebar,.togglebar-wrapper-header", handlers.accordian);
    jQuery("body").on("click", ".readmore", handlers.readmore);
    jQuery("body").on("click", ".tgdetails", handlers.tgdetails);
    jQuery("body").on("click", ".tgschedule", handlers.tgschedule);
    jQuery("body").on("click", ".tgscpechart", handlers.tgscpechart);
    if (utils.isInIFrame()) jQuery("body").on("click", "#loginModal-container a", handlers.loginModalLink);
    if (window._natpAnalytics) jQuery("body").on("click", "a", googleAnalytics.trackClick);
};


// WEBPACK FOOTER //
// ./src/scripts/onload/events.js